(function () {

    'use strict';

    /**
     * @ngdoc service
     * @name BB:BBWidget
     *
     * @description
     * Representation of an BBWidget Object
     *
     * @property {integer} uid The unique id of the widget
     * @property {string} page_suffix Widget page suffix
     * @property {array} steps The widget steps
     * @property {array} allSteps The all steps of the widget
     * @property {object} item_defaults Widget defaults item
     * @property {boolean} Checks if widget using basket or not
     * @property {boolean} confirmCheckout Checks if widget confirm is checkout or not
     * @property {boolean} isAdm,in Verify if user is admin
     * @property {string} payment_status The payment status
     */

    class BBWidgetService {

        constructor($q, BBModel, $urlMatcherFactory, $location, BreadcrumbService, PathHelper, GeneralOptions, $translate, bbWidgetRoutes) {

            this.injections = {
                $q,
                BBModel,
                $urlMatcherFactory,
                $location,
                BreadcrumbService,
                PathHelper,
                GeneralOptions,
                $translate,
                bbWidgetRoutes
            };

            Object.assign(
                this,
                this.injections,
                BBWidgetService.initValues()
            );

        }

        /*
         Class function for the instance initial values
         */
        static initValues() {
            return {
                uid: _.uniqueId('bbwidget_'),
                page_suffix: '',
                steps: [],
                allSteps: [],
                item_defaults: {},
                usingBasket: false,
                confirmCheckout: false,
                isAdmin: false,
                payment_status: null
            };
        }

        /*
         Reconstruct the object
         */
        getNewInstance() {
            const initValues = BBWidgetService.initValues();

            initValues.injections = this.injections;

            for (const key in this) {
                if (angular.isUndefined(initValues[key])) {
                    delete this[key];
                } else {
                    this[key] = initValues[key];
                }
            }

            Object.assign(
                this,
                this.injections
            );

            return this;
        }

        /**
         * @ngdoc method
         * @name pageURL
         * @methodOf BB:BBWidget
         * @description
         * Return the html file name of the route/page
         *
         * @param {string} route
         * @returns {string} Full template file name
         */
        pageURL(route) {
            return `${route}.html`;
        }

        /**
         * @ngdoc method
         * @name updateRoute
         * @methodOf BB:BBWidget
         * @description
         * Update the route
         *
         * @param {string} route
         * @returns {string} The page`s composed url
         */
        updateRoute(page) {
            let company, date, event, event_group, prms, service_name, time, url;
            if (!this.routeFormat) {
                return;
            }
            page || (page = this.current_page);
            const pattern = this.$urlMatcherFactory.compile(this.routeFormat);                        
            service_name = '-';
            event_group = '-';
            event = '-';
            if (this.current_item) {
                if (this.current_item.service) {
                    service_name = this.convertToDashSnakeCase(this.current_item.service.name);
                }
                if (this.current_item.event_group) {
                    event_group = this.convertToDashSnakeCase(this.current_item.event_group.name);
                }
                if (this.current_item.event) {
                    event = this.current_item.event.id;
                }
                if (this.current_item.date) {
                    date = this.current_item.date.date;
                }
                if (date && moment.isMoment(date)) {
                    date = date.toISODate();
                }
                if (this.current_item.time) {
                    time = this.current_item.time.time;
                }
                if (this.current_item.company) {
                    company = this.convertToDashSnakeCase(this.current_item.company.name);
                } else {
                    console.log('%c bb_warning: Make sure you are using a valid company_id', 'background: #c0392b; color: #fff');
                }
            }
            if (this.route_values) {
                prms = angular.copy(this.route_values);
            }
            prms || (prms = {});

            angular.extend(prms, {
                page,
                company,
                service: service_name,
                event_group,
                date,
                time,
                event
            });

            url = pattern.format(prms);
            url = url.replace(/\/+$/, '');
            this.$location.path(url.split('~2F').reverse()[0]);
            this.routing = true;
            return url;
        }

        /**
         * @ngdoc method
         * @name setRouteFormat
         * @methodOf BB:BBWidget
         * @description
         * Set route format and the received default values from the URL
         *
         * @param {string} route the received route format inside the widget configuration
         * @returns {object} The found matches for the current path under the given route format
         */
        setRouteFormat(route) {
            this.routeFormat = route;
            if (!this.routeFormat) {
                return;
            }
            const match = this.PathHelper.matchRouteToPath(this.routeFormat);            
            this.routing = true;
            if (match) {
                if (match.company) {
                    this.item_defaults.company = decodeURIComponent(match.company);
                }
                if (match.service && match.service !== '-') {
                    this.item_defaults.service = decodeURIComponent(match.service);
                }
                if (match.event_group && match.event_group !== '-') {
                    this.item_defaults.event_group = match.event_group;
                }
                if (match.event && match.event !== '-') {
                    this.item_defaults.event = decodeURIComponent(match.event);
                }
                if (match.person) {
                    this.item_defaults.person = decodeURIComponent(match.person);
                }
                if (match.resource) {
                    this.item_defaults.resource = decodeURIComponent(match.resource);
                }
                if (match.resources) {
                    this.item_defaults.resources = decodeURIComponent(match.resoures);
                }
                if (match.date) {
                    this.item_defaults.date = match.date;
                }
                if (match.time) {
                    this.item_defaults.time = parseInt(match.time);
                }
                this.route_matches = match;

                return this.route_matches;
            }
        }

        /**
         * @ngdoc method
         * @name convertToDashSnakeCase
         * @methodOf BB:BBWidget
         * @description
         * Match the given url's page part to the path
         *
         * @returns {number} Step number
         */
        matchURLToStep() {
            const page = this.PathHelper.matchRouteToPath(this.routeFormat, 'page');
            const step = this.allSteps.filter(step => step && step.page == page);

            return step.length ? step[0].number : null;
        }

        /**
         * @ngdoc method
         * @name convertToDashSnakeCase
         * @methodOf BB:BBWidget
         * @description
         * Change the given string into the snake case style
         *
         * @param {string} str
         * @returns {string} Converted string
         */
        convertToDashSnakeCase(str) {
            // Polyfill for IE support
            return str.toLowerCase().replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '').replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|'’!<>;:,.~`=-@£&%"]/g, '').replace(/\s+/g, '-');
        }

        /**
         * @ngdoc method
         * @name recordCurrentPage
         * @methodOf BB:BBWidget
         * @description
         * Record current page
         *
         * @returns {boolean} Last step reached state
         */
        recordCurrentPage() {
            let match, title;
            const setDocumentTitle = (title) => {
                if (this.GeneralOptions.update_document_title && title) {
                    return document.title = this.$translate.instant(title);
                }
            };
            if (!this.current_step) {
                this.current_step = 0;
            }
            match = false;
            if (this.allSteps) {
                this.allSteps.forEach((step) => {
                    if (step.page === this.current_page) {
                        this.current_step = step.number;
                        setDocumentTitle(step.title);
                        match = true;
                    }
                });
            }
            if (!match) {
                this.steps.forEach((step) => {
                    if (step && step.page === this.current_page) {
                        this.current_step = step.number;
                        setDocumentTitle(step.title);
                        match = true;
                    }
                });
            }
            if (!match) {
                this.current_step += 1;
            }
            title = '';
            if (this.allSteps) {
                this.allSteps.forEach((step) => {
                    step.active = false;
                    step.passed = step.number < this.current_step;
                });
                if (this.allSteps[this.current_step - 1]) {
                    this.allSteps[this.current_step - 1].active = true;
                    title = this.allSteps[this.current_step - 1].title;
                }
            }
            return this.recordStep(this.current_step, title);
        }

        /**
         * @ngdoc method
         * @name recordStep
         * @methodOf BB:BBWidget
         * @description
         * Updates the steps` state according to the current step number
         *
         * @param {number} stepNumber Current step number
         * @param {str} title Current step title
         * @returns {boolean} Last step reached state
         */
        recordStep(stepNumber, title) {
            this.steps[stepNumber - 1] = {
                url: this.updateRoute(this.current_page),
                current_item: this.current_item.getStep(),
                page: this.current_page,
                number: stepNumber,
                title,
                stacked_length: this.stacked_items.length
            };

            this.BreadcrumbService.setCurrentStep(stepNumber);

            this.steps.forEach((step) => {
                if (step) {
                    step.passed = step.number < this.current_step;
                    step.active = step.number === this.current_step;

                    if (step.number === stepNumber) {
                        this.calculatePercentageComplete(step.number);
                    }
                }
            });

            this.last_step_reached = (this.allSteps && this.allSteps.length === stepNumber) || this.current_page === 'checkout';

            return this.last_step_reached;
        }

        /**
         * @ngdoc method
         * @name calculatePercentageComplete
         * @methodOf BB:BBWidget
         * @description
         * Calculate completed percentage for the given step
         *
         * @param {number} stepNumber Step number
         * @returns {number} Completed percentage
         */
        calculatePercentageComplete(stepNumber) {
            this.percentage_complete = stepNumber && this.allSteps ? Math.ceil(stepNumber / this.allSteps.length * 100) : 0;

            return this.percentage_complete;
        }

        /**
         * @ngdoc method
         * @name setRoute
         * @methodOf BB:BBWidget
         * @description
         * Set current route
         *
         * @param {array} routesArray
         * @returns {object} Resolved promise
         */
        setRoute(routesArray = []) {

            this.allSteps = [];
            this.nextSteps = {};

            /*
             *  Initializing the bbWidgetRoutes service
             */
            this.bbWidgetRoutes.steps = routesArray;

            if (routesArray.length) {
                this.firstStep = routesArray[0].page;
            }

            routesArray.forEach((step, stepIndex) => {
                if (step.disable_breadcrumbs) {
                    this.disableGoingBackAtStep = stepIndex + 1;
                }

                if (routesArray[stepIndex + 1]) {
                    this.nextSteps[routesArray[stepIndex].page] = routesArray[stepIndex + 1].page;
                }

                
                if (!step.hidden) {
                    this.allSteps.push({
                        number: stepIndex + 1,
                        title: step.title,
                        page: routesArray[stepIndex].page
                    });
                }

                if (step.when) {
                    this.routeSteps || (this.routeSteps = {});
                    const referencedStates = step.when || [];
                    referencedStates.forEach((state) => {
                        this.routeSteps[state] = routesArray[stepIndex].page;
                    });
                }
            });

            if (this.$wait_for_routing) {
                return this.$wait_for_routing.resolve();
            }
        }

        /**
         * @ngdoc method
         * @name waitForRoutes
         * @methodOf BB:BBWidget
         * @description
         * Set $wait_for_routing promise
         *
         * @returns {object} $wait_for_routing promise
         */
        waitForRoutes() {
            //TODO: remove this logic and improve move the logic into something more USEFUL AND MAINTAINABLE
            if (!this.$wait_for_routing) {
                this.$wait_for_routing = this.$q.defer();
                return this.$wait_for_routing;
            }
        }

        /**
         * @ngdoc method
         * @name stackItem
         * @methodOf BB:BBWidget
         * @description
         * Push the item in stacked items
         *
         * @param {object} item Item
         * @returns {object} Current item
         */
        stackItem(item) {
            this.stacked_items.push(item);
            this.sortStackedItems();
            if (this.stacked_items.length === 1) {
                return this.current_item = item;
            }
        }

        /**
         * @ngdoc method
         * @name setStackedItems
         * @methodOf BB:BBWidget
         * @description
         * Set stacked items
         *
         * @param {object} items Stacked items
         * @returns {object} Sorted stacked items
         */
        setStackedItems(items) {
            this.stacked_items = items;
            return this.sortStackedItems();
        }

        /**
         * @ngdoc method
         * @name sortStackedItems
         * @methodOf BB:BBWidget
         * @description
         * Sort stacked items
         *
         * @returns {object} Sorted stacked items
         */
        sortStackedItems() {
            let arr = [];
            this.stacked_items.forEach((stackedItem) => {
                arr = arr.concat(stackedItem.promises);
            });

            return this.$q.all(arr)['finally']((function (_this) {
                return function () {
                    return _this.stacked_items = _this.stacked_items.sort((a, b) => {
                        let ref1, ref2;
                        if (a.time && b.time) {
                            return (ref1 = a.time.time > b.time.time) != null ? ref1 : {
                                1: -1
                            };
                        } else if (a.service.category && !b.service.category) {
                            return 1;
                        } else if (b.service.category && !a.service.category) {
                            return -1;
                        } else if (!b.service.category && !a.service.category) {
                            return 1;
                        } else {
                            return (ref2 = a.service.category.order > b.service.category.order) != null ? ref2 : {
                                1: -1
                            };
                        }
                    });
                };
            })(this));
        }

        /**
         * @ngdoc method
         * @name deleteStackedItem
         * @methodOf BB:BBWidget
         * @description
         * Remove item from both basket and stack
         *
         * @param {object} item Item
         */
        deleteStackedItem(item) {
            if (item && item.id) {
                this.BBModel.Basket.$deleteItem(item, this.company, {
                    bb: this
                });
            }
            return this.removeItemFromStack(item);
        }

        /**
         * @ngdoc method
         * @name removeItemFromStack
         * @methodOf BB:BBWidget
         * @description
         * Remove item from stack
         *
         * @param {object} item Item
         */
        removeItemFromStack(item) {
            return this.stacked_items = this.stacked_items.filter((i) => {
                return i !== item;
            });
        }

        /**
         * @ngdoc method
         * @name deleteStackedItemByService
         * @methodOf BB:BBWidget
         * @description
         * Remove item from stack according to the given item`s service
         *
         * @param {object} item Item
         */
        deleteStackedItemByService(item) {
            const ref = this.stacked_items;
            let i, j, len;
            for (j = 0, len = ref.length; j < len; j++) {
                i = ref[j];
                if (i && i.service && i.service.self === item.self && i.id) {
                    this.BBModel.Basket.$deleteItem(i, this.company, {
                        bb: this
                    });
                }
            }
            return this.stacked_items = this.stacked_items.filter((i) => {
                return i && i.service && i.service.self !== item.self;
            });
        }

        /**
         * @ngdoc method
         * @name emptyStackedItems
         * @methodOf BB:BBWidget
         * @description
         * Remove all items from stack
         */
        emptyStackedItems() {
            this.stacked_items = [];
            return this.stacked_items;
        }

        /**
         * @ngdoc method
         * @name emptyStackedItems
         * @methodOf BB:BBWidget
         * @description
         * Create a new basket and put all the stacked items inside the basket
         */
        pushStackToBasket() {
            this.basket || (this.basket = new this.BBModel.Basket(null, this));
            this.stacked_items.forEach(item => this.basket.addItem(item));

            return this.emptyStackedItems();
        }

        /**
         * @ngdoc method
         * @name totalStackedItemsDuration
         * @methodOf BB:BBWidget
         * @description
         * Get total duration in the stacked items
         */
        totalStackedItemsDuration() {
            let duration = 0;

            this.stacked_items.forEach((item) => {
                if (item.service && item.service.listed_duration) {
                    duration += item.service.listed_duration;
                }
            });

            return duration;
        }

        /**
         * @ngdoc method
         * @name clearStackedItemsDateTime
         * @methodOf BB:BBWidget
         * @description
         * Remove the date and time fields from the stacked items
         */
        clearStackedItemsDateTime() {
            const results = this.stacked_items.map(item => item.clearDateTime());

            return results;
        }

        /**
         * @ngdoc method
         * @name clearAddress
         * @methodOf BB:BBWidget
         * @description
         * Remove all address fields
         */
        clearAddress() {

            Array.from(new Array(5), (val, index) => delete this[`address${index}`]);
        }

    }

    angular.module('BBPublicBooking').service('BBWidget', BBWidgetService);
})();



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/public-booking/widget/bb_widget.service.js